export default "__VITE_ASSET__DGzxd_Cm__"